import {get, post, put, destroy} from './config';

const File = {
    add: (formData) =>
        post('/v1/files/new-document', formData),
    addOrderDoc: (formData) =>
        post('/v1/files/order/document', formData),
    uploadDocument: (data) =>
        post(`v1/files/document`, data),
    uploadDocumentDriver: (data) =>
        post(`v1/files/document/expeditor-driver`, data),
    get: (type) =>
        get(`v1/files/document/${type}`, {responseType: 'blob'}),
    getProfileLogo: () =>
        get(`v1/files/profile-image64`),
    getImageByType: (type, id, params) =>                        // deleted
        get(`v1/files/image-base64/${id}?type=${type}`, {params}),
    getDocApp: (orderId) =>
        get(`v1/documents/document-nod/${orderId} `, {responseType: 'blob'}),
    checkDocApp: (userId) =>
        get(`v1/files/document/check-client-docs/${userId}`),
    getFilesByOrder: (orderId, type) => 
        get(`v1/files/order/document/list/by-order-${orderId}?type=${type}`),
    downloadFileById: (fileId) =>
        get(`v1/files/order/document/download/${fileId}`, {responseType: 'blob'}),
    getOrderDocsDriverPhotos: (orderId) =>
        get(`/v1/files/order/documents/driver-photos?orderId=${orderId}`), 
    getDriverPhoto: (driverId) =>
        get(`v1/files/driver/profile-image64?driverId=${driverId}`),
    addVehicleFile: (data) =>
        post('v1/files/document/vehicle', data),
    getDocDeposit: (price) => 
        get(`/v1/documents/payment-invoice-deposit/pdf?price=${price}`, {responseType: 'blob'}),
    getDocPayment: (orderId) => 
        get(`/v1/documents/payment-invoice/pdf/${orderId}`, {responseType: 'blob'}),
    getDocList: (userId) =>
        get(`v1/files/document/list/by-user-${userId}`),
    deleteDocument: (id) =>
        destroy(`v1/files/document/${id}`),
    deleteDocumentOrders: (fileId) =>
        destroy(`v1/files/order/document/${fileId}`),
    getDocumentByUser: (type, userId) =>
        get(`v1/files/document/${type}/by-user-${userId}`, { responseType: 'blob' }),
    getDocumentByCompany: (type, id) =>
        get(`v1/files/document/${type}/by-company-${id}`, { responseType: 'blob' }),
    getDocById: (fileId) => 
        get(`v1/files/document/by-${fileId}`, { responseType: 'blob' }),
    getDocListVehicle: (vehicleId) =>
        get(`v1/files/document/list/vehicle/by-${vehicleId}`),
    downloadOrderZipDriver: (orderId) =>
        get(`/v1/files/document/download-zip?orderId=${orderId}`, { responseType: 'blob', timeout: 300000 }),
    downloadZipByOrderId: (orderId) =>
        get(`/v1/files/document/order/download-zip?orderId=${orderId}`, { responseType: 'blob', timeout: 300000 }),
    downloadZipByAirOrderId: (orderId) =>
        get(`/v1/files/document/air-order/download-zip?orderId=${orderId}`, { responseType: 'blob', timeout: 300000 }),
    getOrderPdf: (orderId, lang) =>
        get(`/v1/documents/orders/${orderId}/pdf/${lang}`, { responseType: 'blob' }),
    getAirOrderPdf: (orderId) =>
        get(`/v1/documents/air-orders/${orderId}/pdf`, { responseType: 'blob' }),
    uploadChatFile: (formData) =>
        post('/v1/chatfiles', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        }),
    getChatFiles: (chatId) =>
        get(`/v1/chatfiles/${chatId}`),
    getChatFilesByOrder: (orderId) =>
        get(`/v1/chatfiles/by-order-${orderId}`),
    downloadChatFile: (chatId) =>
        get(`/v1/chatfiles/download/${chatId}`, {
            responseType: 'blob',
        }),
    uploadBulkOrders: (formData) =>
        post('/v1/importexcell/upload', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        }),
}


export default File;
